import { S3_FOLDER } from "@erp/shared/api/generated/wrappers/s3";
import { INBOUND_STATUS, ORDER_APPROVAL_PHASE, TRANSFER_STATUS, } from "@erp/shared/types/order-approval-phase.types";
export const 발주업체관련첨부 = [
    {
        key: "orderConfirmationFile",
        dateKey: null,
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "발주 확인서",
        s3Folder: S3_FOLDER.ORDER_CONFIRMATION,
    },
    {
        key: "businessRegistrationFile",
        dateKey: null,
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "사업자 등록증",
        s3Folder: S3_FOLDER.ORDER_BUSINESS_REGISTRATION,
    },
    {
        key: "bankbookFile",
        dateKey: null,
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "통장 사본",
        s3Folder: S3_FOLDER.ORDER_BANKBOOK,
    },
];
export const 전자세금계산서 = [
    {
        key: "firstBill",
        dateKey: "firstBillDate",
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "1차 전자세금계산서",
        s3Folder: S3_FOLDER.ORDER_BILL,
    },
    {
        key: "secondBill",
        dateKey: "secondBillDate",
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "2차 전자세금계산서",
        s3Folder: S3_FOLDER.ORDER_BILL,
    },
    {
        key: "thirdBill",
        dateKey: "thirdBillDate",
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "3차 전자세금계산서",
        s3Folder: S3_FOLDER.ORDER_BILL,
    },
];
export const 송금확인증 = [
    {
        key: "firstConfirmTransfer",
        dateKey: null,
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "1차 송금 확인증",
        s3Folder: S3_FOLDER.ORDER_CONFIRM_TRANSFER,
    },
    {
        key: "secondConfirmTransfer",
        dateKey: null,
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "2차 송금 확인증",
        s3Folder: S3_FOLDER.ORDER_CONFIRM_TRANSFER,
    },
    {
        key: "thirdConfirmTransfer",
        dateKey: null,
        fileName: null,
        fileUrl: null,
        issueDate: null,
        label: "3차 송금 확인증",
        s3Folder: S3_FOLDER.ORDER_CONFIRM_TRANSFER,
    },
];
export const initialChipInfo = {
    key: null,
    dateKey: null,
    fileName: null,
    fileUrl: null,
    issueDate: null,
    label: "",
    s3Folder: null,
};
export const orderDetailHeaders = [
    { text: "종류", align: "start", value: "type" },
    { text: "분류", align: "start", value: "classification" },
    { text: "관리코드", align: "start", value: "productCode" },
    { text: "제품명", align: "start", value: "name" },
    { text: "모델명", align: "start", value: "model" },
    { text: "사양", align: "start", value: "spec" },
    { text: "제조사", align: "start", value: "manufacturer" },
    { text: "발주 수량", align: "start", value: "purchaseNum" },
    { text: "견적서 파일", align: "start", value: "purchaseEstimateFile" },
    { text: "입고 상태", align: "center", value: "actions" },
];
export const orderInboundProductHeaders = [
    { text: "승인 단계", align: "start", value: "approvalPhase" },
    { text: "입고 일자", align: "start", value: "inboundDate" },
    { text: "입고위치", align: "start", value: "spot" },
    { text: "입고수량", align: "start", value: "num" },
    { text: "입고금액", align: "start", value: "unitPrice" },
];
export const orderInProgressCheck = [
    {
        validator: (order) => !!order,
        errorMessage: "발주 정보가 없습니다.",
    },
    {
        validator: (order) => order?.approvalPhase === ORDER_APPROVAL_PHASE.진행중,
        errorMessage: "발주 승인 단계가 진행중이 아닙니다.",
    },
];
export const orderCompleteCheck = [
    {
        validator: (order) => order.inboundPhase === INBOUND_STATUS.입고완료,
        errorMessage: "구매 완료 전 입고완료를 진행해야 합니다.",
    },
    {
        validator: (order) => order.transferPhase === TRANSFER_STATUS.송금완료,
        errorMessage: "구매 완료 전 송금완료를 진행해야 합니다.",
    },
];
